module.exports = __webpack_public_path__ + "static/media/collab-collection.3f594ffc.svg";